import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex cursor-pointer flex-col items-center justify-center',
    arrow: 'relative block animate-[blink-arrow_1.6s_ease-in-out_infinite]',
    arrowDelayed:
      'relative block animate-[blink-arrow_1.6s_ease-in-out_infinite] [animation-delay:.4s]'
  }
});
